import { ChevronLeft, ChevronRight } from "lucide-react";
import { useShop } from "../../context/ShopContext";

export default function Pagination() {
  const {
    currentPage,
    totalPages,
    setCurrentPage,
  } = useShop();

  if (totalPages <= 1) return null;

  return (
    <div className="mt-16 flex items-center justify-center gap-3">

      <button
        disabled={currentPage === 1}
        onClick={() => setCurrentPage(currentPage - 1)}
        className="rounded-full border p-3 disabled:opacity-40"
      >
        <ChevronLeft size={18} />
      </button>

      {[...Array(totalPages)].map((_, index) => (
        <button
          key={index}
          onClick={() => setCurrentPage(index + 1)}
          className={`h-12 w-12 rounded-full transition ${
            currentPage === index + 1
              ? "bg-[#6B8E5F] text-white"
              : "border hover:bg-[#6B8E5F] hover:text-white"
          }`}
        >
          {index + 1}
        </button>
      ))}

      <button
        disabled={currentPage === totalPages}
        onClick={() => setCurrentPage(currentPage + 1)}
        className="rounded-full border p-3 disabled:opacity-40"
      >
        <ChevronRight size={18} />
      </button>

    </div>
  );
}